import React from "react";
import { Button } from "reactstrap";
import ReusableModal from "../../../components/Modals/ReusableModal";
import TermsAndConditions from "../../examples/TaC";

const RegisterModals = ({
  tac, setTac,
}) => {
  return (
    <ReusableModal
      isOpen={tac}
      toggle={() => setTac(false)}
      size="xl"
      scrollable
      footer={
        <Button color="primary" onClick={() => setTac(false)}>
          I Agree
        </Button>
      }
    >
      <TermsAndConditions />
    </ReusableModal>
  );
};

export default RegisterModals;
